<div class="modal-dialog">
    <div class="modal-content">

        <div class="modal-header">
            <div class="row">
                <div class="col-6" > {{ 'LABELS.NEFT_RTGS_CREDIT' | translate}}</div>
                <div  class="col-6">{{neftBalance | inrdisplay}}</div>  
            </div>
            
            <button type="button" class="btn  fis-btn" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
    
        <div class="modal-body">
            <div class="grid-structure">      
                <div class="row" *ngIf="(neftStatementList && neftStatementList.length)">
                    <div>{{ 'LABELS.LAST_10_TRANSACTIONS' | translate}}</div>
                </div>
                <div class="row" *ngFor="let neftState of neftStatementList">
                    <div class="col-9">                 
                        <div class="row">
                            <div class="nTDate">{{neftState.date}}</div>      
                            <div class="nTTxt">{{neftState.type}}</div>
                            <div class="nTAmnt">{{neftState.amt | inrdisplay}}</div>                                
                        </div>
                        <div class="row">
                            <div><small>{{ 'LABELS.UTR' | translate}} {{neftState.utr}}</small></div> 
                        </div>
                    </div>
                </div>       
                <div class="row" *ngIf="!(neftStatementList && neftStatementList.length)">
                    <div class="col-9">
                        <p>{{ 'LABELS.DID_NOT_FIND_NEFT_TRANSACTIONS' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal-footer">
            <button class="btn  fis-btn"  (click)="close()">
                {{ 'LABELS.CLOSE' | translate}}
            </button>
        </div>
    
    </div>

</div>
  
    